module.exports = "<div class=\"gw-modal-header\">\n    <h3>{{ title }}</h3>\n</div>\n<div class=gw-modal-body>\n    <div class=\"gw-clearfix\">\n        <div class=\"gw-span2\"></div>\n        <div class=\"gw-span8\">\n            <div class=\"gw-progress gw-progress-striped gw-active\">\n                <div class=\"gw-bar\" style=\"width: 100%;\"></div>\n            </div>\n        </div>\n        <div class=\"gw-span2\"></div>\n    </div>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/modal/templates/progress-template.html
 ** module id = 524
 ** module chunks = 0
 **/